var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgNoteEdit(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 18,
    height: 18,
    viewBox: "0 0 18 18",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M17.0214 3.92038L14.053 0.952051C13.6656 0.588155 13.158 0.379357 12.6267 0.365375C12.0953 0.351392 11.5774 0.533202 11.1714 0.876218L1.42138 10.6262C1.07121 10.9793 0.853179 11.4422 0.803882 11.9371L0.338049 16.4545C0.323456 16.6132 0.344045 16.7732 0.398349 16.923C0.452653 17.0728 0.539335 17.2088 0.652216 17.3212C0.753443 17.4216 0.873493 17.5011 1.00548 17.555C1.13747 17.6089 1.27881 17.6362 1.42138 17.6354H1.51888L6.03638 17.2237C6.53125 17.1744 6.99409 16.9564 7.34722 16.6062L17.0972 6.85622C17.4756 6.45643 17.6802 5.92293 17.6659 5.37263C17.6517 4.82233 17.4199 4.3001 17.0214 3.92038ZM5.84138 15.0571L2.59138 15.3604L2.88388 12.1104L9.00472 6.06538L11.9297 8.99039L5.84138 15.0571ZM13.338 7.53872L10.4347 4.63538L12.5472 2.46872L15.5047 5.42622L13.338 7.53872Z",
    fill: "#cccccc"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgNoteEdit);
export default __webpack_public_path__ + "note-edit.5a88dfa1c98b7fb747c2a9512908316d.svg";
export { ForwardRef as ReactComponent };